import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  1fr 1fr 1fr;
        .col {
          margin-block: 20px;
          display: flex;
          flex-direction: column;
          text-align: center;
          gap: 5px;
          .title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
          }
          .text{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-sm);
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }

  @media (max-width: 550px){
    .row {
      grid-template-columns:  1fr 1fr !important;
    }
  }
`;

const SurucuArayanlarContainerMobile = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
 
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              <p className="title">Aranacak Telefon No</p>
              <p className="text"></p>{data?.contactNumber}
            </div>
            <div className="col">
              <p className="title">Çalışacak İl / İller</p>
              <p className="text"></p>{data?.driverSeekerWorkCities?.$values?.map((item) => {return( <span>{item.city},{" "}</span> )})}
            </div>
            <div className="col">
              <p className="title">Alınacak Sürücü Sayısı</p>
              <p className="text"></p>{data?.driverCount}
            </div>
            <div className="col">
              <p className="title">Maaş</p>
              <p className="text"></p>{data?.salary}
            </div>
            <div className="col">
              <p className="title">Diğer Yan Haklar</p>
              <p className="text"></p>{data?.otherBenefits}
            </div>
            <div className="col">
              <p className="title">Hafta Tatili</p>
              <p className="text"></p>{data?.weekHoliday}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SurucuArayanlarContainerMobile;
